import MuiDivider, { type DividerProps } from '@mui/material/Divider';

export { DividerProps };

export default function Divider(props: DividerProps) {
  return <MuiDivider {...props} />;
}
